import { services as s } from "@/services";

import { PageT } from "../app/navigation-content";
import type { TabKeyT } from "../tabs";

export const filterAppNavigation = (navigationContent: PageT[], tabs: TabKeyT[], userLabelNames: string[] = []) => {
    const filtered = navigationContent
        .filter((page) => !page.tab || tabs.includes(page.tab))
        .filter((page) => {
            if (!page.labels || page.labels.length === 0) return true;
            return s.hasCommonElements(page.labels, userLabelNames);
        });
    return filtered;
};
